<template>
  <v-row class="vangrupo-container pa-1">
    <!-- SNACKBAR -->
    <v-snackbar
      v-model="snack"
      :color="snackColor"
      :timeout="snackTime"
      bottom
      right
    >
      {{ snackText }}
    </v-snackbar>
    <!-- BUSCADOR -->
    <v-dialog v-model="dialog" persistent max-width="1000px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Clientes VanGrupo</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="busqueda"
                  label="Buscar"
                  dense
                  hint="Búsqueda por Nombre o DUI (sin guion)"
                  clearable
                  append-icon="fa-search"
                  @keypress.enter="buscarCliente"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-data-table
              :headers="headers"
              :items="info.data"
              :single-expand="true"
              item-key="id_uuid"
              :loading="loading"
              loading-text="Buscando clientes VanGrupo..."
              no-data-text="No hay ningún cliente.."
              show-expand
              class="elevation-1"
            >
              <template v-slot:[`item.nombre`]="{ item }">
                {{ `${item.nombre.trim()} ${item.apellidos.trim()}` }}
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                      class="text-right font-weight-bold py-1"
                      >ID:</v-col
                    >
                    <v-col cols="12" md="auto" class="py-1">{{
                      item.id_uuid
                    }}</v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                      class="text-right font-weight-bold py-1"
                      >Empresa:</v-col
                    >
                    <v-col cols="12" md="auto" class="py-1">{{
                      item.empresa
                    }}</v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                      class="text-right font-weight-bold py-1"
                      >Fecha Vigencia:</v-col
                    >
                    <v-col cols="12" md="auto" class="py-1">{{
                      item.fecha_vigencia
                    }}</v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                      class="text-right font-weight-bold py-1"
                      >Cuotas en Mora:</v-col
                    >
                    <v-col cols="12" md="auto" class="py-1">{{
                      item.coutasmora
                    }}</v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                      class="text-right font-weight-bold py-1"
                      >Total Mora:</v-col
                    >
                    <v-col cols="12" md="auto" class="py-1">{{
                      item.totalmora
                    }}</v-col>
                  </v-row>
                </td>
              </template>
              <template v-slot:[`item.estado`]="{ item }">
                <v-chip
                  :color="
                    item.estado.toLowerCase() == 'activo' ? 'green' : 'red'
                  "
                  dark
                >
                  {{ item.estado }}
                </v-chip>
              </template>
              <template v-slot:[`item.seleccionar`]="{ item }">
                <v-btn
                  text
                  fab
                  small
                  color="primary"
                  @click="selectCliente(item)"
                  ><v-icon>fa-check</v-icon></v-btn
                >
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- VISTA DE COMPONENTE -->
    <v-col class="pa-0">
      <v-text-field
        v-model="internalId"
        label="UUID"
        readonly
        outlined
        dense
      ></v-text-field>
    </v-col>
    <v-col class="pa-0" v-if="!disabled">
      <v-btn fab small @click="dialog = true" :disabled="disabled">
        <v-icon> list </v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";

export default {
  name: "MiniVanGrupo",
  props: {
    vanGrupoId: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    snack: false,
    snackColor: "primary",
    snackText: "default",
    snackTime: 6000,
    loading: false,
    internalId: null,
    dialog: false,
    busqueda: "",
    info: {},
    headers: [
      {
        text: "Nombre",
        value: "nombre",
        align: "center",
      },
      {
        text: "DUI",
        value: "dui",
        width: 120,
        align: "center",
      },
      {
        text: "Tipo Tercero",
        value: "tipo_tercero",
        align: "center",
      },
      {
        text: "Tipo Servicio",
        value: "tipo_servicio",
        align: "center",
      },
      {
        text: "Estado",
        value: "estado",
        width: 100,
        align: "center",
      },
      {
        text: "Seleccionar",
        value: "seleccionar",
        align: "center",
      },
    ],
  }),
  methods: {
    buscarCliente() {
      if (this.busqueda == "" || this.busqueda == null) return;

      this.loading = true;

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      const getToken = localStorage.getItem("tokenVanGrupo");

      axios
        .post(
          "api/VanGrupo/BuscarCliente",
          {
            Busqueda: this.busqueda,
            Token: getToken,
          },
          configuracion
        )
        .then((res) => {
          this.info = res.data;

          if (this.info.data.length == 0) {
            this.snackText = this.info.msg;
            this.snackColor = "error";
            this.snack = true;
          } else {
            localStorage.setItem("tokenVanGrupo", res.data.token);
          }
        })
        .catch((err) => console.log(err))
        .finally(() => (this.loading = false));
    },
    selectCliente(item) {
      const cliente = { ...item };

      if (cliente.tipo_tercero == "0001") {
        cliente.titularPoliza = `${cliente.nombre.trim()} ${cliente.apellidos.trim()}`;
        cliente.titularPolizaId = cliente.id_uuid;
        cliente.DUI = cliente.dui;
      } else {
        const titular = this.info.data.filter(
          (cliente) => cliente.tipo_tercero == "0001"
        );

        if (titular.length > 0) {
          cliente.titularPoliza = `${titular[0].nombre.trim()} ${titular[0].apellidos.trim()}`;
          cliente.titularPolizaId = titular[0].id_uuid;
          cliente.DUI = titular[0].dui;
        }
      }

      this.$emit("cliente-seleccionado", cliente);
      this.dialog = false;
      this.internalId = cliente.id_uuid;
    },
  },
  created() {
    if (this.vanGrupoId) {
      this.internalId = this.vanGrupoId;
    }
  },
};
</script>

<style>
.vangrupo-container {
  width: 250px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 0.5em;
}
</style>